import React, { useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Input,
  Text,
  Heading,
  Textarea,
  useToast,
  Spinner,
  Icon,
} from '@chakra-ui/react';
import { FiUpload, FiDownload, FiRefreshCw } from 'react-icons/fi';
import { initMaskingHttpService, maskingPdf, maskingTxt } from '../../../../services/http/maskingFileHttpService';
import createAxiosInstance from '../../../../interceptors/useAxiosInterceptors';
import logout from '../../../../services/authService';
import { useTranslation } from 'react-i18next';
import { useSession } from '../../../../SessionContext';
import { useNavigate } from 'react-router-dom';



const PRIMARY_COLOR = '#084C54';
const BACKGROUND_COLOR = '#f8f6ef';

const FileCleaner = () => {
  const [fileInputKey, setFileInputKey] = useState(Date.now());

  const [selectedFile, setSelectedFile] = useState(null);
  const [fileContent, setFileContent] = useState('');
  const [fileType, setFileType] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

    const [blobResponse, setBlobResponse] = useState();


  const [processedBlob, setProcessedBlob] = useState(null); // per download
const [pdfUrl, setPdfUrl] = useState(null);    

  const { t } = useTranslation();

  const { clearSessionData } = useSession();

  const navigate = useNavigate();
  
  const axiosInstance = createAxiosInstance(async (axiosInstance) => {

    logout(t, clearSessionData, navigate, toast, axiosInstance)
  });
    initMaskingHttpService(t, toast, axiosInstance);
  

const handleFileChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const extension = file.name.split('.').pop().toLowerCase();
  if (!['pdf', 'txt'].includes(extension)) {
    toast({
      title: 'File non supportato',
      description: 'Seleziona un file PDF o TXT.',
      status: 'error',
      duration: 5000,
      isClosable: true,
    });
    return;
  }

  setSelectedFile(file);
  setFileType(extension);
  setIsLoading(true);
  setFileContent('');
  setProcessedBlob(null);
  setPdfUrl(null);

  try {
    let blob;
 
    if (extension === 'txt') {
          console.log(extension)
      blob = await maskingTxt(file, ()=> {}); // restituisce Blob



    

      const text = await blob.text();
      setFileContent(text); // visualizza nella Textarea
      setProcessedBlob(blob);
    } else if (extension === 'pdf') {
          console.log(extension)
      blob = await maskingPdf(file, ()=> {}); // restituisce Blob PDF
      const url = URL.createObjectURL(blob);
      setPdfUrl(url +"#toolbar=0"); // mostra nel preview PDF
      setProcessedBlob(blob);
    }
      setBlobResponse(blob)
  } catch (err) {
    toast({
      title: 'Errore durante l\'elaborazione del file',
      description: String(err),
      status: 'error',
      duration: 5000,
      isClosable: true,
    });
  } finally {
    setIsLoading(false);
  }
};

  



  const handleTextChange = (e) => {
    setFileContent(e.target.value);
  };

 const handleDownload = () => {


  
  if (!selectedFile || !processedBlob) return;

  const element = document.createElement('a');
  element.href = URL.createObjectURL(processedBlob);
  element.download = `Pulito_${selectedFile.name}`;
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
};

const handleReset = () => {
  setSelectedFile(null);
  setFileContent('');
  setFileType('');
  setPdfUrl(null);
  setProcessedBlob(null);
  setFileInputKey(Date.now()); // 👈 forza il reset effettivo
};
  return (
    <Flex direction="column" minH="100vh" bg={BACKGROUND_COLOR} color={PRIMARY_COLOR}>
      <Box p={4} textAlign="center">
        <Heading size="lg" color={PRIMARY_COLOR}>File Masking 📄🔒 </Heading>
        <Text fontSize="sm">
          {t('toastMsg.fileMasking.title')}
        </Text>
      </Box>

      <Flex flex="1" direction="column" overflow="hidden">
        <Box flex="0 0 auto" p={4}>
          <Flex gap={4} align="center" justify="center" flexWrap="wrap">
            {/* Custom File Input */}
            <Box flex="0 0 350px" textAlign="center">

                {!selectedFile && (
              <label htmlFor="file-upload">
                <Flex
                  align="center"
                  justify="center"
                  bg="white"
                  border="2px dashed"
                  borderColor={PRIMARY_COLOR}
                  borderRadius="xl"
                  p={3}
                  cursor="pointer"
                  _hover={{ bg: 'gray.50' }}
                  transition="all 0.3s ease"
                >
                  <Icon as={FiUpload} mr={2} />
                  <Text> {t('toastMsg.fileMasking.selectFile')}</Text>
                </Flex>
              </label>)}
             <Input
              key={fileInputKey} // 👈 forza il reset dell'input
              id="file-upload"
              type="file"
              accept=".pdf,.txt"
              onChange={handleFileChange}
              display="none"
              />
              {selectedFile && (
                <Box
                  mt={2}
                  fontSize="sm"
                  color={PRIMARY_COLOR}
                  overflowX="auto"
                  whiteSpace="nowrap"
                  maxW="100%"
                  borderRadius="md"
                  bg="white"
                  p={2}
                  css={{
                    '&::-webkit-scrollbar': {
                      height: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      background: PRIMARY_COLOR,
                      borderRadius: '24px',
                    },
                  }}
                >
                  {selectedFile.name}
                </Box>
              )}
            </Box>
            
            {selectedFile && (
            <Button
              leftIcon={<FiDownload />}
              colorScheme="teal"
              variant="solid"
              size="xl"
              borderRadius="full"
              height="48px"
              px={6}
              onClick={handleDownload}
              isDisabled={!selectedFile || isLoading}
            >
              Download
            </Button>)}
            {selectedFile && (
            <Button
              leftIcon={<FiRefreshCw />}
              colorScheme="orange"
              variant="outline"
              size="xl"
              borderRadius="full"
              height="48px"
              px={6}
              onClick={handleReset}
            >
              Refresh
            </Button>)}
          </Flex>
        </Box>

        <Box flex="1" overflow="hidden" p={4} position="relative">
       {isLoading ? (
  <Flex align="center" justify="center" h="100%">
    <Spinner size="xl" color={PRIMARY_COLOR} />
  </Flex>
) : (
  selectedFile && (
    <Box h="85%" overflow="auto" marginTop={"4%"}>
      <Textarea
        value={fileContent}
        isReadOnly={true}
        onChange={handleTextChange}
        w="100%"
        h="85%"
        resize="none"
        bg="white"
        borderColor={PRIMARY_COLOR}
        _hover={{ borderColor: PRIMARY_COLOR }}
        _focus={{
          borderColor: PRIMARY_COLOR,
          boxShadow: `0 0 0 1px ${PRIMARY_COLOR}`,
        }}
        display={fileType === 'txt' ? 'block' : 'none'}
      />
      {fileType === 'pdf' && pdfUrl && (
<Box flex="1" overflow="auto" p={4} position="relative" height={"90%"}>
  <iframe
    title="Anteprima PDF"
    src={pdfUrl}
    width="100%"
    height="100%"
    style={{ border: '1px solid #ccc', borderRadius: '8px' }}
  />
</Box>
      )}
    </Box>
  )
)}
        </Box>
      </Flex>
    </Flex>
  );
};

export default FileCleaner;
